import { Member } from '@services/member/member/member.types';
import { PRINT_STYLES } from './printStyles';
import { 
    generateAdministrativeSection, 
    generatePersonalInfoSection, 
    generateSocialBenefitsSection,
    generateFinancialBenefitsSection,
    generateContributionsSection,
    generateBookingsSection
} from './printSections';

/**
 * Génère le HTML complet pour l'impression de la fiche adhérent
 * @param member - Les données du membre à imprimer
 * @returns HTML formaté pour l'impression
 */
export const generatePrintHTML = (member: Member): string => {
    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Fiche Adhérent - ${member.fullname}</title>
            <style>${PRINT_STYLES}</style>
        </head>
        <body>
            <h1>FICHE ADHÉRENT - APERÇU</h1>
            ${generateAdministrativeSection(member)}
            ${generatePersonalInfoSection(member)}
            ${generateSocialBenefitsSection(member)}
            ${generateFinancialBenefitsSection(member)}
            ${generateContributionsSection(member)}
            ${generateBookingsSection(member)}
        </body>
        </html>
    `;
};